export const serviceListIndustriales = [
    {
        "title": "SERVICIO DE",
        "subtitle": "<span>LIMPIEZA Y PROTECCIÓN CON RECUBRIMIENTOS</span><br /> ANTICORROSIVOS <br />INDUSTRIALES",
        "description": "El óxido en las estructuras es una amenaza constante que debilita el metal y pone en riesgo la estabilidad y durabilidad de la misma. Dale la limpieza adecuada con nuestros servicios especializados.",
        "features": ["Rope Access", "Nivel 0", "Sandblast", "Pintura Especializada"],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg"
        ],
        "bgColor": "#1226AA"
    },
    {
        "title": "SERVICIO DE",
        "subtitle": "<span>INSPECCIÓN Y </span><br />MANTENIMIENTO",
        "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
        "features": [
            "Rope Access",
            "Estructural",
            "Concreto",
            "Inspección con Pruebas No Destructivas (PND)."
        ],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg"
        ],
        "bgColor": "#1226AA"
    },
    {
        "title": "SERVICIO DE",
        "subtitle": "<span>IMPERMEABILIZACIÓN Y AISLAMIENTO TÉRMICO</span><br />Y ACÚSTICO EN ESTRUCTURAS INDUSTRIALES",
        "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
        "features": [
            "Rope Access",
            "Juntas Constructivas",
            "Concreto",
            "Aislamientos Térmicos y Acústicos",
            "Acero",
            "Durock",
        ],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg"
        ],
        "bgColor": "#1226AA"
    },
    {
        "title": "SERVICIO DE",
        "subtitle": "INSTALACIóN",
        "description": "La prevención es la clave para tener en óptimas condiciones sus estructuras. Nosotros realizamos las inspecciones necesarias de manera no invasiva.",
        "features": [
            "Estructuras de Acero",
            "Tubería Especializada",
            "Anclajes",
            "Drenajes",
            "Instalación Eléctrica",
            "Luminarias",
            "Alucobond",
        ],
        "buttonText": "CONTACTANOS",
        "images": [
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg"
        ],
        "bgColor": "#1226AA"
    },
]

export const serviceListIndustrialesEn = [
    {
        title: "SERVICE OF",
        subtitle: "<span>RUST CLEANING AND ANTICORROSIVE COATINGS</span><br />FOR INDUSTRIAL STRUCTURES",
        description:
            "Rust on structures is a constant threat that weakens metal and jeopardizes stability and durability. Give them the proper cleaning with our specialized services.",
        features: [
            "Vertical Rope Access",
            "Level 0",
            "Sandblasting",
            "Specialized Painting"
        ],
        buttonText: "CONTACT US",
        "images": [
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg",
            "/assets/imgs/services/industriales/serviceList/1.jpg"
        ],
        bgColor: "#1226AA"
    },
    {
        title: "SERVICE OF",
        subtitle: "<span>INSPECTION AND </span><br />MAINTENANCE",
        description:
            "Prevention is the key to keeping your structures in optimal condition. We carry out necessary inspections in a non-invasive manner.",
        features: [
            "Vertical Rope Access",
            "Structural",
            "Concrete",
            "Non-Destructive Testing (NDT)"
        ],
        buttonText: "CONTACT US",
        "images": [
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg",
            "/assets/imgs/services/industriales/serviceList/2.jpg"
        ],
        bgColor: "#1226AA"
    },
    {
        title: "SERVICE OF",
        subtitle: "<span>WATERPROOFING AND THERMAL INSULATION</span><br />& ACOUSTIC IN INDUSTRIAL STRUCTURES",
        description:
            "Prevention is the key to keeping your structures in optimal condition. We carry out necessary inspections in a non-invasive manner.",
        features: [
            "Rope Access",
            "Construction Joints",
            "Concrete",
            "Thermal & Acoustic Insulation",
            "Steel",
            "Durock"
        ],
        buttonText: "CONTACT US",
        "images": [
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg",
            "/assets/imgs/services/industriales/serviceList/3.jpg"
        ],
        bgColor: "#1226AA"
    },
    {
        title: "SERVICE OF",
        subtitle: "<span>INSTALLATION</span>",
        description:
            "Prevention is the key to keeping your structures in optimal condition. We carry out necessary inspections in a non-invasive manner.",
        features: [
            "Steel Structures",
            "Specialized Piping",
            "Anchors",
            "Drainage",
            "Electrical Installation",
            "Lighting",
            "Alucobond"
        ],
        buttonText: "CONTACT US",
        "images": [
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg",
            "/assets/imgs/services/industriales/serviceList/4.jpg"
        ],
        bgColor: "#1226AA"
    }
];

